// TO DO: Move this to a more global location.
export const ISO_DATE_FORMAT = "yyyy-MM-dd" as const
export const ISO_TIME_FORMAT = "hh:mm" as const
export const ISO_UTC_TIME_FORMAT = "HH:mm:ssZ" as const
export const ISO_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss" as const
